import { ErrorHandler } from "@components/ErrorHandler";
import { Toaster as ToasterSonner } from "sonner";
import { useAutoAuth } from "./modules/auth/hooks/useAutoAuth";
import AppRoutes from "./routes";
import Menu from "./components/common/Menu";
import { useEffect } from "react";
import WebApp from "@twa-dev/sdk";
import { useAuthStore } from "./modules/auth";
import { useUserStore } from "./modules/auth/store/user";
import ScrollToTop from "./components/common/ScrollToTop";
import Toaster from "./components/common/toaster/Toaster";
import Auth from "./components/layout/auth/Auth";
import ToasterLight from "./components/common/toaster/ToasterLight";
import { Icon } from "./components/common/icon/Icon";

export default function App() {
  useAutoAuth();

  const { user, isAuthLoading } = useUserStore();
  const isMiniApp = !!WebApp.initData;
  const { accessToken } = useAuthStore();

  useEffect(() => {
    if (isMiniApp) {
      // Main app background
      WebApp.setHeaderColor("#EFEFF4");
      WebApp.setBackgroundColor("#EFEFF4");
      WebApp.setBottomBarColor("#EFEFF4");
    }
  }, [isMiniApp]);

  if (!isMiniApp && !user && !accessToken && !isAuthLoading) {
    return (
      <div className="w-full max-w-[48rem] mx-auto h-full flex flex-col items-center justify-center">
        <Auth />
        <ToasterLight />
      </div>
    );
  }

  if (
    !user
    //  || (!isMiniApp && isAuthLoading)
  ) {
    return (
      <div className="w-full max-w-[48rem] mx-auto h-full flex items-center justify-center">
        <Icon type="loading" className="w-10 h-10 fill-link animate-spin" />
      </div>
    );
  }

  return (
    <>
      <ScrollToTop />
      <ToasterSonner position="top-center" richColors />
      <Toaster />
      <ErrorHandler />

      <div
        id="app"
        className="app flex-grow flex flex-col w-full max-w-[48rem] mx-auto h-full relative"
        style={{
          paddingBottom: "calc(4rem + var(--tg-safe-area-inset-bottom))",
        }}
      >
        <AppRoutes />

        <Menu />
      </div>
    </>
  );
}
